export default {
  user_avatar: 0,
  logo_image: 1,
  cover_picture_image: 2,
  user_cover_image: 4,
};
